import { Component, Input, OnChanges, OnInit, Output, EventEmitter } from '@angular/core';
import { Award, Profile, Student } from '@app/definitions/interfaces';
import { HandlerService } from '@app/_services/handler.service';
import { AccountService } from '@teacher/services/account.service';
import { AchievementsService } from '@app/results/services/achievements.service';
import { MatDialog } from '@angular/material/dialog';

import { Router } from '@angular/router';

// :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

@Component({
    selector: 'app-profile-awards',
    templateUrl: './profile-awards.component.html',
    styleUrls: ['./profile-awards.component.scss']
})
export class ProfileAwardsComponent implements OnInit, OnChanges {
    @Input() student: Student;
    @Output() navBack = new EventEmitter();
    @Output() editAward = new EventEmitter();
    awards: Array<Award>;
    countShow: number = 5;
    userId: number;
    profile: Profile;

    constructor(
        private achievementsService: AchievementsService,
        private accountService: AccountService,
        public dialog: MatDialog,
        private router: Router,
        private handlerService: HandlerService
    ) {}

    ngOnInit() {
        if (this.student) {
            this.userId = this.student.user.id;
            this.getUserAwards(this.userId);
            return;
        }

        this.accountService.getProfileData().subscribe(resp => {
            this.profile = resp.data;
            this.userId = this.profile.user.id;
            this.getUserAwards(this.userId);
        });
    }

    private getUserAwards(userId): void {
        this.achievementsService.getUserAwards(userId).subscribe(resp => {
            this.handlerService.checkErrors(resp);
            this.awards = resp.data;
        });
    }

    ngOnChanges() {
        this.userId = this.student.user.id;
        this.getUserAwards(this.userId);
    }

    loadNext(): void {
        this.countShow += 5;
    }

    showAll(): void {
        this.countShow = this.awards.length;
    }

    openPreviw(award: Award): void {
        if (this.student) {
            localStorage.setItem('selectedAward', String(award.id));
            this.editAward.emit();
            return;
        }
        this.router.navigate([`profile/awards/${this.userId}/${award.id}`]);
    }

    back() {
        this.navBack.emit();
    }
}
